import { createGameCatalog } from '@cardforest/games/catalog';

export const games = createGameCatalog('production');
export const DEFAULT_GAME_ID = 'bridge';
